const SAFE_COUNTRY_PREFIX = /^[A-Za-z0-9_-]{1,32}$/
const INVALID_STORED_AUTH_TOKENS = [
  'null',
  'undefined',
  'false',
  '0',
  'mock',
  'fallback',
  'readOnly',
  'read_only',
  'blocked',
  'backendBlocked',
  'backend_blocked',
  'writeBlocked',
  'write_blocked',
  'need_login',
  'needlogin',
  'login_required',
  'session_expired',
  'token_expired',
  'expired_token',
  'unauthorized'
]

export function safeCountryPrefix(value) {
  const prefix = String(value || '').trim()
  return SAFE_COUNTRY_PREFIX.test(prefix) ? prefix : ''
}

export function normalizeStoredAuthToken(value) {
  const token = String(value == null ? '' : value).trim()
  if (!token) return ''
  const lower = token.toLowerCase()
  const invalidTokens = INVALID_STORED_AUTH_TOKENS.map(item => item.toLowerCase())
  if (invalidTokens.includes(lower)) return ''
  return token
}

export function isStoredAuthToken(value) {
  return !!normalizeStoredAuthToken(value)
}

export function countryRoutePath(prefix, routeName) {
  const cleanPrefix = safeCountryPrefix(prefix)
  const cleanRoute = String(routeName || '')
    .trim()
    .replace(/^\/+/, '')
  if (cleanPrefix && cleanRoute) return `/${cleanPrefix}/${cleanRoute}`
  if (cleanPrefix) return `/${cleanPrefix}`
  return cleanRoute ? `/${cleanRoute}` : '/'
}

export function collectValidSubPaths(routes) {
  const subPaths = new Set()
  const addPath = (path) => {
    const cleanPath = String(path || '')
      .replace(/^\/:prefix\?\//, '')
      .replace(/^\/:prefix\?/, '')
      .replace(/^\//, '')
    const segment = cleanPath.split('/').filter(Boolean)[0]
    if (segment && !segment.startsWith(':')) {
      subPaths.add(segment)
    }
  }

  routes.forEach((route) => {
    addPath(route.path)
    const children = route.children || []
    children.forEach((child) => addPath(child.path))
  })
  return subPaths
}

export function fullPathSuffix(to) {
  return String(to.fullPath || '').slice(String(to.path || '').length)
}

export function withCurrentQueryAndHash(path, to) {
  return `${path}${fullPathSuffix(to)}`
}

export function firstPathSegment(to) {
  return String(to.path || '').split('/').filter(Boolean)[0] || ''
}

export function getSubPath(to, validSubPaths) {
  const segments = String(to.path || '').split('/').filter(Boolean)
  if (!segments.length) return '/'
  if (validSubPaths.has(segments[0])) return `/${segments[0]}`
  return `/${segments[1] || ''}`
}

export function loginRedirect(prefix, to) {
  return {
    path: countryRoutePath(prefix, 'home'),
    query: {
      isValue: 'isLogin',
      redirect: to.fullPath
    }
  }
}
